import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, Table, Row, Col, Button } from "reactstrap";
import ReportForm from "./Form";
import ReportHit from "./Hit";
import { fetchReports, createReport } from "./Axios";
import Notifications from "../commons/Notifications";

const REPORT_TYPES = [
  { label: "Reporte de Candidatos", value: "applicants" },
  { label: "Reporte de Publicaciones", value: "publications" },
  { label: "Reporte de Postulaciones", value: "postulations" }
];

const ReportsIndex = () => {
  const [selectedType, setSelectedType] = useState(null);
  const [reports, setReports] = useState([]);
  const [polling, setPolling] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  const notifications = useRef(null);

  const showNotification = (title, message, type) => {
    notifications.current.addNotifications(title, message, type);
  };

  const loadReports = (type) => {
    fetchReports(type, res => {
      if (res.status === 200) setReports(res.data);
    });
  };

  const handleCreate = (filters) => {
    const hasActiveReport = reports.some(r => ["pending", "processing"].includes(r.status));
    if (hasActiveReport) {
      showNotification("Espera un momento", "Ya hay un reporte en proceso para este tipo. Debes esperar a que finalice.", "warning");
      return;
    }

    createReport(selectedType, filters, res => {
      if (res.status === 200) {
        showNotification("En proceso", "El reporte se está generando.", "success");
        setReports([res.data, ...reports]);
        setReloadKey(prev => prev + 1);
      } else {
        showNotification("Error", "No se pudo generar el reporte.", "danger");
      }
    });
  };

  const handleSelectType = (type) => {
    setSelectedType(type);
    setReports([]);
    setReloadKey(prev => prev + 1);
    loadReports(type);
  };

  // Polling eficiente y reiniciable
  useEffect(() => {
    if (!selectedType) return;

    loadReports(selectedType);

    const intervalId = setInterval(() => {
      fetchReports(selectedType, res => {
        if (res.status === 200) {
          const newReports = res.data;
          const stillProcessing = newReports.some(r => ["pending", "processing"].includes(r.status));

          setReports(newReports);

          if (!stillProcessing) {
            clearInterval(intervalId);
            setPolling(null);
          }
        }
      });
    }, 5000);

    setPolling(intervalId);
    return () => clearInterval(intervalId);
  }, [selectedType, reloadKey]);

  const hasActiveReport = reports.some(r => ["pending", "processing"].includes(r.status));

  return (
    <>
      <Notifications ref={notifications} />

      {!selectedType ? (
        <Card className="material-shadow">
          <CardBody>
            <h3 className="h4">Selecciona el tipo de reporte</h3>
            <Row className="mt-4">
              {REPORT_TYPES.map((option) => (
                <Col md="4" key={option.value} className="mb-3">
                  <Card body className="text-center h-100 border">
                    <h5>{option.label}</h5>
                    <Button color="primary" onClick={() => handleSelectType(option.value)}>
                      Seleccionar
                    </Button>
                  </Card>
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      ) : (
        <>
          <Card className="mb-4 material-shadow">
            <CardBody>
              <Row className="d-flex justify-content-between align-items-center">
                <Col md="8">
                  <h3 className="h4">Reporte: {REPORT_TYPES.find(r => r.value === selectedType).label}</h3>
                  <p className="text-muted small">Completa los filtros para generar el reporte.</p>
                </Col>
                <Col md="4" className="text-right">
                  <Button color="link" onClick={() => {
                    setSelectedType(null);
                    if (polling) clearInterval(polling);
                  }}>← Cambiar tipo</Button>
                </Col>
              </Row>
              <ReportForm
                reportType={selectedType}
                onCreated={handleCreate}
                showNotification={showNotification}
                disabled={hasActiveReport}
              />
            </CardBody>
          </Card>

          <Card className="material-shadow">
            <CardBody>
              <h5 className="mb-3">Reportes generados</h5>
              <Table>
                <thead>
                <tr>
                  <th>#</th>
                  <th>Rango</th>
                  <th>Estado</th>
                  <th>Creado</th>
                  <th>Solicitado por</th>
                  <th>Archivo</th>
                </tr>
                </thead>
                <tbody>
                {reports.map((report, index) => (
                  <ReportHit key={report.id} index={index} report={report} />
                ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </>
      )}
    </>
  );
};

export default ReportsIndex;
